var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 0.5H14.375V2.41667H12.4583V4.33333H10.5417V2.41667H8.625V0.5Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91667 2.41667V4.33333H0V0.5H3.83333V2.41667H1.91667Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4583 9.125H10.5417V11.0417H8.625V12.9583H10.5417V14.875H12.4583V12.9583H14.375V11.0417H12.4583V9.125Z",
    fill: "#414042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91667 11.0417H3.83333V12.9583H1.91667V14.875H0V9.125H1.91667V11.0417Z",
    fill: "#414042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 11.0417H21.0833V9.125H23V14.875H21.0833V12.9583H19.1667V11.0417Z",
    fill: "#414042"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4583 19.6667H10.5417V21.5833H8.625V23.5H14.375V21.5833H12.4583V19.6667Z",
    fill: "#414042"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91667 19.6667H0V23.5H3.83333V21.5833H1.91667V19.6667Z",
    fill: "#414042"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23 4.33333H21.0833V2.41667H19.1667V0.5H23V4.33333Z",
    fill: "#414042"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19.6667H21.0833V21.5833H19.1667V23.5H23V19.6667Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLot);
export default __webpack_public_path__ + "static/media/Lot.9e07f8a51a6d02edad15b38bf3439a24.svg";
export { ForwardRef as ReactComponent };